export var JumpShipStatusType;
(function (JumpShipStatusType) {
    JumpShipStatusType[JumpShipStatusType["IN_PROCESS"] = 1] = "IN_PROCESS";
    JumpShipStatusType[JumpShipStatusType["SUCCESSFUL"] = 2] = "SUCCESSFUL";
    JumpShipStatusType[JumpShipStatusType["FAIL"] = 3] = "FAIL";
    JumpShipStatusType[JumpShipStatusType["CANCEL"] = 4] = "CANCEL";
    JumpShipStatusType[JumpShipStatusType["PENDING"] = 5] = "PENDING";
})(JumpShipStatusType || (JumpShipStatusType = {}));
//# sourceMappingURL=JumpShipStatusType.js.map